export default __webpack_public_path__ + "static/media/barbites.3e8329e9.png";